<template>
  <div>
    <v-app-bar app color="white" height="100">
      <v-avatar class="mr-3" color="grey lighten-5" size="70">
        <v-img
          contain
          max-height="70%"
          :src="getApiUrl + '/images/logos/logo.png'"
        ></v-img>
      </v-avatar>
      <v-toolbar-title class="font-weight-black headline">{{
        siteName
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <span
          v-for="(item, i) in menu"
          :key="i + Math.random() + Math.random()"
        >
          <v-btn
            v-if="
              getAuthenticated &&
                (item.route == 'switchboard' || item.route == 'school-website')
            "
            text
            style="color:black"
            :to="{ name: item.route }"
          >
            <v-icon left>{{ item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </v-btn>
          <v-btn
            v-else-if="
              !getAuthenticated &&
                (item.route == 'school-website' ||
                  item.route == 'bitsems-register' ||
                  item.route == 'bitsems-login')
            "
            text
            style="color:black"
            :to="{ name: item.route }"
          >
            <v-icon left>{{ item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </v-btn>
        </span>

        <v-btn
          v-if="getAuthenticated"
          text
          rounded
          style="color:black"
          @click="signOut"
        >
          <v-icon left @click="signOut">exit_to_app</v-icon>
          <span>Sign Out</span>
        </v-btn>
      </div>

      <div class="hidden-md-and-up">
        <v-row>
          <v-menu transition="slide-x-transition" bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text fab v-bind="attrs" v-on="on">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>

            <v-list
              :style="{
                'background-color': 'white',
                color: 'black',
                opacity: 0.7,
              }"
            >
              <br />
              <br />
              <br />
              <v-layout
                v-for="(item, i) in menu"
                :key="i + Math.random() + Math.random()"
                class="justify-left"
              >
                <v-btn
                  v-if="
                    getAuthenticated &&
                      (item.route == 'switchboard' ||
                        (item.route == 'school-website' && notSameRoute()))
                  "
                  text
                  :style="{ color: 'black', display: 'block' }"
                  :to="{ name: item.route }"
                >
                  <v-icon left>{{ item.icon }}</v-icon>
                  <span>{{ item.title }}</span>
                </v-btn>
                <v-btn
                  v-else-if="
                    (item.route == 'school-website' && notSameRoute()) ||
                      item.route == 'bitsems-register' ||
                      item.route == 'bitsems-login'
                  "
                  text
                  :style="{ color: 'black', display: 'block' }"
                  :to="{ name: item.route }"
                >
                  <v-icon left>{{ item.icon }}</v-icon>
                  <span>{{ item.title }}</span>
                </v-btn>
              </v-layout>
              <v-btn
                v-if="getAuthenticated"
                text
                rounded
                :style="{ color: 'black', display: 'block' }"
                @click="signOut"
              >
                <v-icon left @click="signOut">exit_to_app</v-icon>
                <span>Sign Out</span>
              </v-btn>
            </v-list>
          </v-menu>
        </v-row>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import helpersJs from "@/plugins/helpers";

export default {
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    itsBitsems() {
      return this.$store.getters.itsBitsems;
    },
  },
  mounted() {
    this.$store.commit("setVuetifyObject", this.$vuetify);

    if (
      localStorage.getItem("token") != null &&
      localStorage.getItem("authenticated") != null
    ) {
      this.$store.commit("setAccessToken", localStorage.getItem("token"));
      this.$store.commit("setAuthenticated", true);
    }
    let domain = "";

    if (window.location.hostname.includes("bitsems")) {
      this.$store.commit("setBitsems", true);
    } else {
      domain = window.location.hostname;
    }

    if (!this.itsBitsems) {
      axios.postData("/get-school-website-banner", { domain }).then((pics) => {
        this.$store.commit("setFrontPageImages", pics);
        axios.postData("/get-school-with-domain", { domain }).then((data) => {
          this.$store.commit("setUserSchool", data.school);
          this.$store.commit("setThemeColor", data.school.primary_bg_color);
          this.$store.commit(
            "setSecondaryColor",
            data.school.secondary_bg_color
          );
          this.$store.commit("setAppName", data.school.schname);
          this.$store.commit("setSiteArticles", data.posts);
          this.$store.commit("setSiteStats", data.stats);

          localStorage.setItem("themeColor", data.school.primary_bg_color);
          localStorage.setItem(
            "secondaryColor",
            data.school.secondary_bg_color
          );
          localStorage.setItem("appName", data.school.schname);
          localStorage.setItem("userSchool", JSON.stringify(data.school));
        });
      });
    }
  },
  data() {
    return {
      schools: [],
      siteName: "BITSEMS",
      menu: [
        {
          icon: "mdi-home",
          title: "Home",
          description: "",
          color: "deep-orange darken-4",
          route: "school-website",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "apps",
          title: "Switchboard",
          description: "",
          color: "deep-orange darken-4",
          route: "switchboard",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "assignment_ind",
          title: "Sign In",
          description: "",
          color: "deep-orange darken-4",
          route: "bitsems-login",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "person_add",
          title: "Create Account",
          description: "",
          color: "deep-orange darken-4",
          route: "bitsems-register",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
      ],
    };
  },
  methods: {
    notSameRoute() {
      if (window.location.pathname != "/") {
        return true;
      } else {
        return false;
      }
    },
    async signOut() {
      await helpersJs.signOut();
    },
  },
};
</script>

<style></style>
